import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {SVGIcon} from '@homeaway/react-svg';
import {INFO__16} from '@homeaway/svg-defs';

/* istanbul ignore next */
const tooltipClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

const BadgeTooltip = ({helpText}) => {
    if (!helpText) {
        return null;
    }

    return (
        <div className={'HitInfo__badgeTooltip'} onClick={tooltipClickHandler}>
            <Tooltip
                centered
                shouldPersist
                hasCloseButton
                trigger="click"
                tooltipType="popover"
                content={helpText}
                placement="top"
                onClick={tooltipClickHandler}
            >
                <SVGIcon inline markup={INFO__16} />
            </Tooltip>
        </div>
    );
};

export default BadgeTooltip;
